import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { syncSessionsMap } from '../sync-session';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getSyncSession: (_, { args }) => {
        return syncSessionsMap.get(args.syncSessionId);
      },
    },
  },
};
